import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AtxListGroupComponent } from './components';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        AtxListGroupComponent,
    ],
    exports: [
        AtxListGroupComponent,
    ],
})

export class AtxListGroupModule {}
